/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, {
  attr,
  belongsTo,
  type AsyncBelongsTo,
} from '@warp-drive/legacy/model';
import { alias } from '@ember/object/computed';
import type { Type } from '@warp-drive/core/types/symbols';
import type TagCategory from '@linc-technologies/linced-common/models/posts/tag-category';
import type School from '@linc-technologies/linced-common/models/school';

// Proto: posts.Tag.
export default class Tag extends Model {
  declare [Type]: 'posts/tag';

  @belongsTo('school', { async: true, inverse: null })
  declare schoolId: AsyncBelongsTo<School>;

  @attr('string', { defaultValue: '' })
  declare campusId: string;

  @attr('number')
  declare createTime: number | undefined;

  @attr('number')
  declare updateTime: number | undefined;

  @attr('string', { defaultValue: '' })
  declare label: string;

  @attr('number', { defaultValue: 0 })
  declare sequence: number;

  @attr('string', { defaultValue: '' })
  declare key: string;

  @belongsTo('posts/tag-category', { async: true, inverse: 'tags' })
  declare categoryId: AsyncBelongsTo<TagCategory>;

  @alias('categoryId')
  declare category: AsyncBelongsTo<TagCategory>;
}
